// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  float: right;
}
.text {
  font-weight: 500;
}
.txt {
  margin: auto;
}
.sel {
  height: 45px;
  width: 200px;
}
.boss {
  height: 45px;
}
.bb {
  margin: auto;
}
.b {
  margin-top: 0.7rem;
  margin-bottom: 0.7rem;
  float: right;
}
.input {
  margin-top: auto;
}
.space {
  margin-top: 35px;
}
.btn-space {
  float: right;
  margin-top: 10px;
}
.btn-gap {
  margin-right: 15px;
}
@media only screen and (max-width: 1024px) {
  .btn-edits {
    margin: auto;
  }
  .sel {
    margin-top: 8px;
  }
  .boss {
    margin-top: 8px;
  }
}
@media only screen and (max-width: 769px) {
  .btn-edits {
    margin: auto;
  }
  .sel {
    margin-top: 8px;
  }
}
@media only screen and (max-width: 454px) {
  .text {
    width: 200px;
    text-align: center;
  }
  .bot {
    flex-direction: column;
  }
}
@media only screen and (max-width: 426px) {
  .space {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .input {
    width: 335px;
  }
  .text {
    margin-left: -25px;
  }
  .buttons {
    margin-right: -14px;
    margin-top: 5px;
    text-align: center;
  }
}
@media only screen and (max-width: 376px) {
  .space {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .input {
    width: 290px;
  }
  .text {
    margin-left: -35px;
  }
  .buttons {
    margin-top: 5px;
    margin-right: -30px;
    text-align: center;
  }
}
@media only screen and (max-width: 320px) {
  .space {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .input {
    width: 230px;
  }
  .text {
    margin-left: -50px;
  }
  .buttons {
    margin-top: 5px;
    margin-right: -35px;
    text-align: center;
  }
}
@media only screen and (max-width: 426px) and (min-width: 320px) {
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .btn-space {
    width: 100%;
  }
  .btn-edits {
    margin: auto;
  }
  .sel {
    margin-top: 8px;
  }
  .len {
    width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/billingPackages.less"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".buttons {\n  float: right;\n}\n.text {\n  font-weight: 500;\n}\n.txt {\n  margin: auto;\n}\n.sel {\n  height: 45px;\n  width: 200px;\n}\n.boss {\n  height: 45px;\n}\n.bb {\n  margin: auto;\n}\n.b {\n  margin-top: 0.7rem;\n  margin-bottom: 0.7rem;\n  float: right;\n}\n.input {\n  margin-top: auto;\n}\n.space {\n  margin-top: 35px;\n}\n.btn-space {\n  float: right;\n  margin-top: 10px;\n}\n.btn-gap {\n  margin-right: 15px;\n}\n@media only screen and (max-width: 1024px) {\n  .btn-edits {\n    margin: auto;\n  }\n  .sel {\n    margin-top: 8px;\n  }\n  .boss {\n    margin-top: 8px;\n  }\n}\n@media only screen and (max-width: 769px) {\n  .btn-edits {\n    margin: auto;\n  }\n  .sel {\n    margin-top: 8px;\n  }\n}\n@media only screen and (max-width: 454px) {\n  .text {\n    width: 200px;\n    text-align: center;\n  }\n  .bot {\n    flex-direction: column;\n  }\n}\n@media only screen and (max-width: 426px) {\n  .space {\n    margin-top: -10px;\n    margin-bottom: -10px;\n  }\n  .input {\n    width: 335px;\n  }\n  .text {\n    margin-left: -25px;\n  }\n  .buttons {\n    margin-right: -14px;\n    margin-top: 5px;\n    text-align: center;\n  }\n}\n@media only screen and (max-width: 376px) {\n  .space {\n    margin-top: -10px;\n    margin-bottom: -10px;\n  }\n  .input {\n    width: 290px;\n  }\n  .text {\n    margin-left: -35px;\n  }\n  .buttons {\n    margin-top: 5px;\n    margin-right: -30px;\n    text-align: center;\n  }\n}\n@media only screen and (max-width: 320px) {\n  .space {\n    margin-top: -10px;\n    margin-bottom: -10px;\n  }\n  .input {\n    width: 230px;\n  }\n  .text {\n    margin-left: -50px;\n  }\n  .buttons {\n    margin-top: 5px;\n    margin-right: -35px;\n    text-align: center;\n  }\n}\n@media only screen and (max-width: 426px) and (min-width: 320px) {\n  .buttons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n  }\n  .btn-space {\n    width: 100%;\n  }\n  .btn-edits {\n    margin: auto;\n  }\n  .sel {\n    margin-top: 8px;\n  }\n  .len {\n    width: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
